var _rect, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path6, _path7, _circle8, _circle9, _ellipse, _ellipse2, _ellipse3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle10, _path18, _circle11, _defs, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#2f3e57"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#47556b",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 48C32 22 48 18 60 18S88 22 86 48L87 76C87 82 81 84 76 82H44C39 84 33 82 33 76Z",
    fill: "#2a1d1a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#26324d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88L60 112L76 88L70 85L60 96L50 85Z",
    fill: "#f4f1ea"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96L57 102L60 118L63 102Z",
    fill: "#1d1a18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90L56 124L30 124C26 108 32 96 40 90ZM80 90L64 124L90 124C94 108 88 96 80 90Z",
    fill: "#1e283d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 104,
    r: 2,
    fill: "#e3b94a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 112,
    r: 2,
    fill: "#e3b94a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 120,
    r: 2,
    fill: "#e3b94a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 104,
    r: 2,
    fill: "#e3b94a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 112,
    r: 2,
    fill: "#e3b94a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 120,
    r: 2,
    fill: "#e3b94a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 112H30M90 112H100M20 116H30M90 116H100",
    stroke: "#e3b94a",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#563224"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#62392a"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#62392a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#62392a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#4c2c20",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48Q51 44 56 47",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48Q69 44 74 47",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52 67Q60 75 68 67",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37 48C34 27 48 21 60 21S86 27 83 48L80 42C70 44 50 44 40 42Z",
    fill: "#2a1d1a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30C33 21 46 15 60 15S87 21 87 30L84 37H36Z",
    fill: "#f4f1ea"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33H84V40H36Z",
    fill: "#1f2a40"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42 40C52 47 68 47 78 40L80 44C68 53 52 53 40 44Z",
    fill: "#1d1a18"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 36.5,
    r: 4,
    fill: "#e3b94a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52 36.5H68",
    stroke: "#e3b94a",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 36.5,
    r: 1.6,
    fill: "#1f2a40"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: "50%",
    cy: "48%",
    r: "72%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#2a1a08",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08",
    stopOpacity: 0.38
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#8a6a3a",
    opacity: 0.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait27);
export default __webpack_public_path__ + "static/media/player-portrait-27.6f27c6fbb93356dfcd86955068c4e617.svg";
export { ForwardRef as ReactComponent };